(function () {
  'use strict';

  var ENDPOINT = '/apps/airx/api/session';
  var STORE_KEY = 'airx:ai-session';
  var TIMEOUT_MS = 8000;
  var SKEW_MS = 60 * 1000;

  var pending = null;

  function readCached() {
    try {
      var raw = sessionStorage.getItem(STORE_KEY);
      if (!raw) return null;
      var v = JSON.parse(raw);
      if (!v || typeof v.token !== 'string') return null;
      if (!(v.expiresAt > Date.now() + SKEW_MS)) return null;
      return v;
    } catch (err) {
      return null;
    }
  }

  function writeCached(token, expiresInS) {
    try {
      sessionStorage.setItem(STORE_KEY, JSON.stringify({
        token: token,
        expiresAt: Date.now() + (Number(expiresInS) || 0) * 1000
      }));
    } catch (err) {  }
  }

  function request() {
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = setTimeout(function () { if (controller) controller.abort(); }, TIMEOUT_MS);
    return fetch(ENDPOINT, {

      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      signal: controller ? controller.signal : undefined
    })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        var token = (data && typeof data.token === 'string') ? data.token : '';
        if (token) {
          writeCached(token, data.expiresIn);
        } else {

          writeCached('', 60 + SKEW_MS / 1000);
        }
        return token;
      })
      .catch(function () { return ''; })
      .finally(function () { clearTimeout(timer); });
  }

  function token() {
    var cached = readCached();
    if (cached) return Promise.resolve(cached.token);

    if (!pending) {
      pending = request().finally(function () { pending = null; });
    }
    return pending;
  }

  function headers(tok, base) {
    var h = {};
    if (base) for (var k in base) if (Object.prototype.hasOwnProperty.call(base, k)) h[k] = base[k];
    if (tok) h['X-AirX-Session'] = tok;
    return h;
  }

  function clear() {
    try { sessionStorage.removeItem(STORE_KEY); } catch (err) {  }
  }

  window.AirXAISession = { token: token, headers: headers, clear: clear };
})();
